import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import {
  validString,
  date,
  decimal,
  percent,
  dateRange,
} from "Components/shared/helpers/validations";

const weightRange = Yup.string().test(
  "compareWeight",
  "weightFrom must be less than weightTo",
  (val, context) => {
    const { weightFrom } = context.parent;
    return val ? parseInt(val) > parseInt(weightFrom) : false;
  },
);

const markupValue = Yup.mixed()
  .when("markupType", {
    is: "PERCENTAGE",
    then: percent.required(),
  })
  .when("markupType", {
    is: "FIXED",
    then: decimal.required(),
    otherwise: validString.optional(),
  });

const rateFields = Yup.object().shape(
  reverseShape({
    weightFrom: decimal.required(),
    weightTo: decimal.required().concat(weightRange),
    priceBeforeSST: decimal.required(),
    priceAfterSST: decimal.required(),
    markupType: validString.optional(),
    markupValue: markupValue,
    markupBeforeSST: decimal.optional(),
    markupAfterSST: decimal.optional(),
  }),
);
const rates = Yup.array(rateFields);

const locations = Yup.array().min(1);

export const RateTableCreateSchema = Yup.object().shape(
  reverseShape({
    code: validString.optional(), // create version
    settingID: validString.optional(), // edit version
    locations: locations.required(),
    validFrom: date.required(),
    validTo: date.required().concat(dateRange),
    rates: rates.required(),
    estimatedDeliveryInDay: validString.required(),
    estimatedTime: validString.required(),
    cutOffTime: validString.required(),
    customerOrgID: Yup.string()
      .when("$isCustomerRequired", {
        is: true,
        then: Yup.string().required(),
      })
      .optional(),
    surchargeType: Yup.string().optional(),
    surchargeFixedAmount: Yup.string().optional(),
    surchargePercentage: Yup.string().optional(),
    surchargeCapAmount: Yup.string().optional(),
  }),
);
